import { createAction } from '@reduxjs/toolkit'
import { type MessageTypes } from './messages-types'

/* Payload types */

export interface AcknowledgeMessagePayload {
  id: string
}

/* Action Creators */

export const AddMessageAction = createAction('messages/add', (message: string, type: MessageTypes, literalMessage?: boolean) => {
  return {
    payload: {
      message: {
        message,
        type,
        id: Date.now().toString(),
        literalMessage: literalMessage ?? false
      }
    }
  }
})

export const AcknowledgeMessageAction = createAction<AcknowledgeMessagePayload>('messages/acknowledge')
